<template>
    <form class="container-fluid m-0 p-0" @submit.prevent="confirmAddUser">

        <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
            <div class="col-sm-12 h-100 my-auto p-0 m-0">
                <span class="mx-3 font-weight-bold lead">Add User</span>

                <span class="float-right py-1 mx-2 pr-4">
                    <button type="submit"
                            class="btn btn-xs btn-outline-primary px-2 mr-1"
                    >
                        <span class="fas fa-save"></span>
                        Save
                    </button>

                    <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                            @click="goBack"
                    >
                        <span class="fas fa-backward"></span>
                        Go Back
                    </button>
                </span>
            </div>
        </div>

        <div class="row text-small m-3">
            <div class="col col-md-6">
                <div class="form-group form-row mb-1" :class="{'has-error': newUserErrors.last_name}">
                    <label class="col col-sm-2 font-weight-bolder col-form-label text-left form-label-xs pt-3 offset-1"
                           for="lastName">
                        Last Name:
                    </label>
                    <div class="col col-sm-6">
                        <input type="text" id="lastName" required
                               class="form-control form-control-xs"
                               placeholder="Last Name"
                               v-model="newUser.last_name"
                        >
                        <span class="help-block text-danger" v-if="newUserErrors.last_name">
                            <small><strong>{{ newUserErrors.last_name }} </strong></small>
                        </span>
                    </div>
                </div>
                <div class="form-group form-row mb-1" :class="{'has-error': newUserErrors.name}">
                    <label class="col col-sm-2 font-weight-bolder col-form-label text-left form-label-xs pt-3 offset-1"
                           for="firstName">
                        First Name:
                    </label>
                    <div class="col col-sm-6">
                        <input type="text" id="firstName" required
                               class="form-control form-control-xs"
                               placeholder="First Name"
                               v-model="newUser.name"
                        >
                        <span class="help-block text-danger" v-if="newUserErrors.name">
                            <small><strong>{{ newUserErrors.name }} </strong></small>
                        </span>
                    </div>
                </div>
                <div class="form-group form-row mb-1" :class="{ 'has-error': newUserErrors.middle_name }">
                    <label class="col col-sm-2 font-weight-bolder col-form-label text-left form-label-xs pt-3 offset-1"
                           for="middleName">
                        Middle Name:
                    </label>
                    <div class="col col-sm-6">
                        <input type="text" id="middleName"
                               class="form-control form-control-xs"
                               placeholder="Middle Name"
                               v-model="newUser.middle_name"
                        >
                        <span class="help-block text-danger" v-if="newUserErrors.middle_name">
                            <small><strong>{{ newUserErrors.middle_name }} </strong></small>
                        </span>
                    </div>
                </div>
                <div class="form-group form-row mb-1" :class="{ 'has-error': newUserErrors.contact }">
                    <label class="col col-sm-2 font-weight-bolder col-form-label text-left form-label-xs pt-3 offset-1"
                           for="contact">
                        Contact:
                    </label>
                    <div class="col col-sm-6">
                        <input type="text" id="contact"
                               class="form-control form-control-xs"
                               placeholder="Contact Number"
                               v-model="newUser.contact"
                        >
                        <span class="help-block text-danger" v-if="newUserErrors.contact">
                            <small><strong>{{ newUserErrors.contact }} </strong></small>
                        </span>
                    </div>
                </div>
                <div class="form-group form-row mb-1" :class="{ 'has-error': newUserErrors.contact }">
                    <label class="col col-sm-2 font-weight-bolder col-form-label text-left form-label-xs pt-3 offset-1"
                           for="email">
                        Email:
                    </label>
                    <div class="col col-sm-6">
                        <input type="email" id="email"
                               class="form-control form-control-xs"
                               placeholder="Email Address"
                               v-model="newUser.email"
                        >
                        <span class="help-block text-danger" v-if="newUserErrors.email">
                            <small><strong>{{ newUserErrors.email }} </strong></small>
                        </span>
                    </div>
                </div>

            </div>
            <div class="col col-md-6">

                <div class="form-group form-row mb-1" :class="{ 'has-error': newUserErrors.username }">
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="username">
                        Username:
                    </label>
                    <div class="col col-sm-6">
                        <input type="text" id="username" required
                               class="form-control form-control-xs"
                               placeholder="Username"
                               v-model="newUser.username"
                        >
                        <span class="help-block text-danger" v-if="newUserErrors.username">
                            <small><strong>{{ newUserErrors.username }} </strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1" :class="{ 'has-error': newUserErrors.password }">
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="password">
                        Password:
                    </label>

                    <div class="col col-sm-6">
                        <div class="input-group" >
                            <input type="password" id="password"
                                   class="form-control form-control-xs"
                                   placeholder="Password"
                                   v-model="newUser.password"
                            >
                            <div class="input-group-append">
                                <button class="btn btn-sm btn-xs" type="button" title="Show Password" @click="showPassword('password')">
                                    <i class="fa fa-eye-slash" aria-hidden="true" id="passwordIcon"></i>
                                </button>
                            </div>
                        </div>
                        <span class="help-block text-danger">
                            <small><strong>{{ newUserErrors.password }} </strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1" :class="{ 'has-error': newUserErrors.confirmPassword }">
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="confirmPassword">
                        Confirm Password:
                    </label>

                    <div class="col col-sm-6">
                        <div class="input-group">
                            <input type="password" id="confirmPassword"
                                   class="form-control form-control-xs"
                                   placeholder="Confirm Password"
                                   v-model="newUser.confirmPassword"
                            >
                            <div class="input-group-append">
                                <button class="btn btn-sm btn-xs" type="button" title="Show Password" @click="showPassword('confirmPassword')">
                                    <i class="fa fa-eye-slash" aria-hidden="true" id="confirmPasswordIcon"></i>
                                </button>
                            </div>
                        </div>
                        <span class="help-block text-danger" v-if="newUserErrors.confirmPassword">
                            <small><strong>{{ newUserErrors.confirmPassword }} </strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1" :class="{ 'has-error': newUserErrors.manning_id }">
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="manning">
                        Manning:
                    </label>
                    <div class="col col-sm-6">
                        <select id="manning"
                                class="form-control form-control-xs"
                                v-model="newUser.manning_id"
                        >
                            <option :value="null">-- SELECT MANNING --</option>
                            <option :value="manningKey.id" v-for="manningKey in manningKeys" :key="manningKey.id">
                                {{ manningKey.alias }}
                            </option>
                        </select>
                        <span class="help-block text-danger" v-if="newUserErrors.manning_id">
                            <small><strong>{{ newUserErrors.manning_id }} </strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1" :class="{ 'has-error': newUserErrors.company_id }">
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="company">
                        Company:
                    </label>
                    <div class="col col-sm-6">
                        <select id="company"
                                class="form-control form-control-xs"
                                v-model="newUser.company_id"
                        >
                            <option :value="null">-- SELECT COMPANY --</option>
                            <option :value="companyKey.id" v-for="companyKey in companyKeys" :key="companyKey.id">
                                {{ companyKey.name }}
                            </option>
                        </select>
                        <span class="help-block text-danger" v-if="newUserErrors.company_id">
                            <small><strong>{{ newUserErrors.company_id }} </strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1" :class="{ 'has-error': newUserErrors.active }">
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="userStatus">
                        Status:
                    </label>

                    <div class="col col-sm-6">
                        <select id="userStatus" required
                                class="form-control form-control-xs"
                                v-model="newUser.active"
                        >
                            <option :value="1">ACTIVE</option>
                            <option :value="0">INACTIVE</option>
                        </select>
                        <span class="help-block text-danger" v-if="newUserErrors.active">
                            <small><strong>{{ newUserErrors.active }} </strong></small>
                        </span>
                    </div>
                </div>

            </div>
        </div>

        <div class="row text-small m-3">
            <div class="col-md-3 offset-1">
                <h5>System Restrictions</h5>
                <div class="form-group row">

                    <div class="col-sm-9 offset-3 text-left mb-2" v-for="systemKey in systemKeys" :key="systemKey.id">
                        <div class="form-check d-block">
                            <input class="form-check-input" type="checkbox"
                                   :value="systemKey.id"
                                   :id="'systemKey' + systemKey.id"
                                   v-model="systemIds"
                            >
                            <label class="form-check-label w-100"
                                   :for="'systemKey' + systemKey.id"
                                   :class="{
                                       'font-weight-bolder text-success' : systemIds.some(systemId => systemId == systemKey.id),
                                       'text-secondary' : !systemIds.some(systemId => systemId == systemKey.id),
                                   }"
                            >
                                {{ systemKey.name }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4 offset-1">
                <h5>POSITIONS / ROLES</h5>
                <div class="form-group row">

                    <div class="col-sm-9 offset-3 text-left mb-2" v-for="positionKey in positionKeys" :key="positionKey.id">
                        <div class="form-check d-block">
                            <input class="form-check-input" type="checkbox"
                                   :value="positionKey.id"
                                   :id="'positionKey' + positionKey.id"
                                   v-model="positionIds"
                            >
                            <label class="form-check-label w-100"
                                   :for="'positionKey' + positionKey.id"
                                   :class="{
                                       'font-weight-bolder text-success' : positionIds.some(positionId => positionId == positionKey.id),
                                       'text-secondary' : !positionIds.some(positionId => positionId == positionKey.id),
                                   }"
                            >
                                {{ positionKey.name }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </form>

</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";

export default {
    name: "UserCreate",
    mixins: [ vueAppMixin ],
    data() {
        return {
            newUser: {
                manning_id: null,
                company_id: null,
                active: 1
            },
            newUserErrors: {
                password: '',
                confirmPassword: '',
            },
            systemIds: [],
            positionIds: []
        }
    },

    methods: {
        ...mapActions([
            'getManningKeys',
            'getSystemKeys',
            'getPositionKeys',
            'addUser',
            'getCompanyKeys'
        ]),

        async confirmAddUser() {

            if(this.newUser.company_id === null && this.newUser.manning_id === null) {
                this.errorAlert('Please Select Either Manning or Company', 'FORM SUBMISSION');
                this.newUserErrors['manning_id'] = 'Please Select Manning'
                this.newUserErrors['company_id'] = 'Please Select Company'
            }

            if(await this.confirmCreateAlert()) {
                if((this.newUser.password || this.newUser.confirmPassword) && !this.verifyPassword()) {
                    this.errorAlert('Password Not Matched', 'PASSWORD ERROR')
                    return false;
                }

                let newUserDetails = {
                    last_name: this.newUser.last_name,
                    name: this.newUser.name,
                    middle_name: this.newUser.middle_name,
                    contact: this.newUser.contact,
                    email: this.newUser.email,
                    username: this.newUser.username,
                    password: this.newUser.password,
                    manning_id: this.newUser.manning_id,
                    company_id: this.newUser.company_id,
                    active: this.newUser.active,
                    systems: this.systemIds,
                    positions: this.positionIds,
                }

                let newCrewId = await this.addUser(newUserDetails);
                if(newCrewId.errors) {
                    this.newUserErrors = newCrewId.errors;
                } else {
                    this.successAlert('New User Successfully Added', 'CREATE');
                    this.$router.push({ name: 'UserShow', params: { id: newCrewId }});
                }

            }
        },

        verifyPassword() {
            let verified = this.newUser.password === this.newUser.confirmPassword;
            if(!verified) {
                this.newUserErrors['confirmPassword'] = 'Password Not Matched';
                this.newUserErrors['password'] = 'Password Not Matched';
            }
            return verified;
        },

        showPassword(passwordId) {
            const passInput = document.getElementById(passwordId);
            const x = document.getElementById(passwordId + 'Icon');
            if (passInput.type === 'password') {
                passInput.type = 'text';
                x.setAttribute('class', 'fa fa-eye');
            } else {
                passInput.type = 'password';
                x.setAttribute('class', 'fa fa-eye-slash');
            }
        },
    },

    computed: {
        ...mapGetters([ 'manningKeys', 'systemKeys', 'positionKeys', 'companyKeys' ])
    },

    created() {
        this.getManningKeys();
        this.getCompanyKeys();
        this.getSystemKeys();
        this.getPositionKeys();
    }


}
</script>

<style scoped>

</style>
